import React, { useState, useContext } from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import { SidebarContext } from "context/SidebarContext";
import { IoIosClose } from "react-icons/io";
// const Tab = ({ label, onClick, isActive }) => {
//   return (
//     <a
//       onClick={onClick}
//       className={`shrink-0 border-b-2 px-1 pb-4 text-sm font-medium ${isActive
//         ? 'border-green-500 text-green-600'
//         : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
//         }`}
//     >
//       {label}
//     </a>
//   );
// };
const Tab = ({ label, onClick, isActive }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`shrink-0 border-b-2 px-1 pb-4 text-sm font-medium focus:outline-none ${
        isActive
          ? "border-green-500 text-green-600"
          : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
      }`}
    >
      {label}
    </button>
  );
};

const ViewModal = ({ id, data }) => {
  const { isViewModalOpen, closeModal } = useContext(SidebarContext);
  var result = data.find((item) => item.id === id);

  const [activeTab, setActiveTab] = useState("1");

  const handleTabClick = (label) => {
    setActiveTab(label);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const closeZoomModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  const style = `{
    .custom-modal button {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-size: 16px;
      color: #333;
      outline:none !important;
    }
    .custom-modal button:hover {
      color: #FF0000 !important; 
      outline:none;
      
    } .custom-modal button:focus {
      color: #FF0000 !important; 
      outline:none; 
    }
    .custom-modal {
      overflow: auto;
    }
    
    `;

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white pl-2 pt-2 pb-2 pr-2 w-1/2"
        isOpen={isViewModalOpen}
        onClose={() => {
          setActiveTab("1");
          closeModal();
        }}
      >
        <ModalBody className="custom-modal">
          <div>
            <div className="border-b border-gray-200">
              <nav className="-mb-px flex gap-6" aria-label="Tabs">
                <Tab
                  label="Partial Payment Details"
                  onClick={() => handleTabClick("1")}
                  isActive={activeTab === "1"}
                />
              </nav>
            </div>

            {/* Tab Content */}
            <div
              className="p-4 max-h-96 overflow-y-auto"
              style={{ maxHeight: "400px" }}
            >
              {activeTab === "1" && (
                <div className="flow-root rounded-lg border border-gray-100 py-3 shadow-sm ml-5 mr-5 mb-5 ">
                  <dl className="-my-3 divide-y divide-gray-100 text-sm">
                    <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                      <dt className="font-medium text-gray-900">
                        More than 24
                      </dt>
                      <dd className="text-gray-700 sm:col-span-2 pl-20">
                        {result?.more_than_24}
                      </dd>
                    </div>

                    <div className="grid grid-cols-1 gap-1 p-3 sm:grid-cols-3 sm:gap-4">
                      <dt className="font-medium text-gray-900">
                        Less than 24
                      </dt>
                      <dd className="text-gray-700 sm:col-span-2 pl-20">
                        {result?.less_than_24}
                      </dd>
                    </div>
                  </dl>
                </div>
              )}

              {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
                  <div className="bg-white dark:bg-gray-600 p-4 rounded-lg max-w-md w-full relative">
                    <button
                      onClick={closeZoomModal}
                      className="viewModelBoxCloseBtn bg-white dark:bg-gray-600 dark:text-white"
                    >
                      <IoIosClose />
                    </button>

                    <img
                      src={process.env.REACT_APP_API_IMAGE_URL + selectedImage}
                      alt="Selected Company Logo"
                      className="w-full h-auto rounded-lg"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewModal);
